import React, { useState, useEffect } from "react"
import * as cookie from "cookie"
import { Spinner } from "../spinner/spinner"
import styles from "./gdprConsent.module.scss"

const COOKIE_OPTIONS = {
  path: "/",
  maxAge: 31536000, // 1 year
  secure: process.env.NODE_ENV === "production",
  sameSite: "lax",
  domain: process.env.NODE_ENV === "production" ? ".ligonier.org" : undefined
} as const

export function GdprConsent() {
  const [isLoadingAccept, setIsLoadingAccept] = useState(false)
  const [isLoadingReject, setIsLoadingReject] = useState(false)
  const [shouldShow, setShouldShow] = useState(false)

  useEffect(() => {
    const cookies = cookie.parse(document.cookie)
    const hasChosen = cookies["gdpr-consent-chosen"] === "true"

    if (!hasChosen) {
      setShouldShow(true)
    }
  }, [])

  const handleConsent = async (accepted: boolean) => {
    if (accepted) {
      setIsLoadingAccept(true)
    } else {
      setIsLoadingReject(true)
    }

    try {
      document.cookie = cookie.serialize(
        "gdpr-consent",
        String(accepted),
        COOKIE_OPTIONS
      )
      document.cookie = cookie.serialize(
        "gdpr-consent-chosen",
        "true",
        COOKIE_OPTIONS
      )

      localStorage.setItem("gdpr-consent", accepted.toString())
      localStorage.setItem("gdpr-consent-chosen", "true")

      setShouldShow(false)

      if (accepted && window.analytics) {
        window.analytics.track("GDPR Consent Accepted", {
          gdprConsent: accepted
        })
      }
    } catch (error) {
      console.error("Error setting cookie consent:", error)
    } finally {
      setIsLoadingAccept(false)
      setIsLoadingReject(false)
    }
  }

  if (!shouldShow) return null

  return (
    <>
      <div className={styles.overlay} />
      <div className={styles.banner}>
        <div className={styles.content}>
          <p className={styles.text}>
            We use several internet technologies to customize your experience
            with our ministry in order to serve you better. To learn more, view
            our{" "}
            <a
              href="https://www.ligonier.org/privacy-policy"
              className={styles.link}
            >
              Privacy Policy
            </a>
            .
          </p>
          <div className={styles.buttonContainer}>
            <button
              onClick={() => handleConsent(true)}
              className={styles.acceptButton}
              disabled={isLoadingAccept}
            >
              {isLoadingAccept ? <Spinner /> : "Accept All"}
            </button>
            <button
              onClick={() => handleConsent(false)}
              className={styles.strictlyNecessaryButton}
              disabled={isLoadingReject}
            >
              {isLoadingReject ? <Spinner /> : "Strictly Necessary"}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
